import { useContext, useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../routes/routes";
import { RoleTypeCode } from "../../utils/Constant";
import { clearAllListStates } from "../../hooks/useListState";
import SubscriptionPlan from "../subscriptionPlan/SubscriptionPlan";
import "./Header.scss";
import OrganizationLogo from "./OrganizationLogo";

function Header() {
  const navigate = useNavigate();
  const handleLogout = () => {
    const keysToKeep = ["email", "rememberMe", "PageRecordLimit"];
    const valuesToKeep = keysToKeep.reduce((acc: any, key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});
    localStorage.clear();
    // Restore the preserved values
    Object.keys(valuesToKeep).forEach((key) => {
      localStorage.setItem(key, valuesToKeep[key]);
    });
    
    // Clear list states stored in sessionStorage
    clearAllListStates();
    
    // localStorage.clear();
    window.location.href = "/login";
    // navigate("/login");
  };
  const { appContextdata } = useContext<any>(UserContext);
  const [organization, setOrganization] = useState("");
  const [userName, setUserName] = useState("");
  const [userNameImage, setUserNameImage] = useState<string>("");
  const [showSubscriptionPanel, setShowSubscriptionPanel] = useState(false);

  useEffect(() => {
    setOrganization(appContextdata?.OrganizationName);
    setUserName(appContextdata?.User?.split(" ")[0]);
    setUserNameImage(
      appContextdata?.User
        ? `${appContextdata?.User[0]}${
            appContextdata?.User?.split(" ")[1]?.[0] || ""
          }`.toUpperCase()
        : ""
    );
  }, [appContextdata?.Role]);

    const handleTopUpHistory = () => {
      navigate("/top-up-history");
    };

  return (
    <div className="nav">
      <Navbar expand="lg" className="navbar bg-white w-100">
        <Container fluid>
          <Navbar.Brand
            href="/dashboard"
            className="d-flex align-items-center gap-lg-2 gap-1"
          >
            <OrganizationLogo />
            <span className="org-name">{organization}</span>
          </Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="navbarScroll" /> */}
          <Navbar>
            <Nav className="ms-auto" navbarScroll>
              <div className="user-detail d-flex align-items-center ">
                <span
                  className={`${
                    userNameImage ? `userName-${userNameImage[0]}` : ""
                  }`}
                >
                  {userNameImage}
                </span>
                <NavDropdown
                  title={userName}
                  id="navbarScrollingDropdown"
                  align="end"
                  className=""
                >
                  <NavDropdown.Item
                    href="#"
                    onClick={() => navigate("/changePassword")}
                  >
                    Change Password
                  </NavDropdown.Item>
                  {(appContextdata?.Role === RoleTypeCode?.Administrator ||
                    appContextdata?.Role === RoleTypeCode?.SuperAdmin) && (
                    <NavDropdown.Item
                      href="#"
                      onClick={() => setShowSubscriptionPanel(true)}
                    >
                      Subscription Plan
                    </NavDropdown.Item>
                  )}
                  {(appContextdata?.Role === RoleTypeCode?.Administrator ||
                    appContextdata?.Role === RoleTypeCode?.SuperAdmin) && (
                    <NavDropdown.Item
                      href="#"
                      onClick={() => handleTopUpHistory()}
                    >
                      Top-Up History
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Item href="#" onClick={handleLogout}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </Nav>
          </Navbar>
        </Container>
      </Navbar>
      <SubscriptionPlan
        visible={showSubscriptionPanel}
        onClose={() => setShowSubscriptionPanel(false)}
        data={appContextdata}
      />
    </div>
  );
}

export default Header;
